import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftVinculationExistProps } from './props';
import { SarlaftVinculationExist } from '../../../../../../shared/types/modules/sarlaft';
import { asyncGetParams } from '../../../../../../services/param.service';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';

export const useSarlaftVinculationExist = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftVinculationExistProps) => {
    const [policiesInsureds, setPoliciesInsureds] = useState<ISelect[]>([]);
    const [policiesBeneficiaries, setPoliciesBeneficiaries] = useState<
        ISelect[]
    >([]);
    const [insuredsBeneficiaries, setInsuredsBeneficiaries] = useState<
        ISelect[]
    >([]);

    const onSubmit = (data: SarlaftVinculationExist) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue(
            'policyHolderInsured',
            data?.policyHolderInsured || ''
        );
        formik?.setFieldValue(
            'policyHolderBeneficiary',
            data?.policyHolderBeneficiary || ''
        );
        formik?.setFieldValue(
            'insuredBeneficiary',
            data?.insuredBeneficiary || ''
        );
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.POLICY_HOLDER_INSURED).then((items) =>
            setPoliciesInsureds(items)
        );
        asyncGetParams(ParamEnum.POLICY_HOLDER_BENEFICIARY).then((items) =>
            setPoliciesBeneficiaries(items)
        );
        asyncGetParams(ParamEnum.INSURED_BENEFICIARY).then((items) =>
            setInsuredsBeneficiaries(items)
        );
    }, []);

    return {
        formik,
        policiesInsureds,
        policiesBeneficiaries,
        insuredsBeneficiaries,
    };
};
